module.exports = "/_next/static/images/license-88b35adee64fcde1304b8ce147a86470.png";